import styles from './Section.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Section = ({ children, className }) => {
  return (
    <section className={classNames(styles.section, className)}>
      {children}
    </section>
  );
};

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Section.defaultProps = {
  children: null,
  className: null,
};

export default Section;
